import { AlertType, AlertWithIllustration } from "Components/Form/Alert";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { TextManager } from "Components/TextContext";
import { IconName } from "Constants/constants";
import React from "react";
import ReactMarkdown from "react-markdown";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import {
  BoatType,
  typeWithMotorOrSail,
} from "Store/interfaces/products/checkout/riskProducts/BoatProduct";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";

interface Props {
  formProps: any;
}

export const Smaabaatregisteret = ({
  formProps,
}: Props): React.ReactElement | null => {
  const { values, setFieldValue } = formProps;
  const { getText } = TextManager;

  const shouldRender =
    typeWithMotorOrSail(values.boatType as BoatType) &&
    values.boatNotPristine === BooleanFormType.FALSE &&
    ((values.injuries === DamageRecentYears.ONE &&
      isDefined(values.injuryYear)) ||
      values.injuries === DamageRecentYears.NONE);

  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <RadioButtonTrueFalse
        name="registeredInSmaabaatregisteret"
        id="registeredInSmaabaatregisteret"
        label={getText("boatform.label.hassmaabaatregisteretmembership")}
        options={getYesOrNoOptions(
          "registeredInSmaabaatregisteret-yes",
          "registeredInSmaabaatregisteret-no",
        )}
        direction="vertical"
        error={getError("registeredInSmaabaatregisteret", formProps)}
        onChange={(e) => {
          if (e.target.value === BooleanFormType.FALSE) {
            setFieldValue("registrationNumber", undefined);
          }
        }}
      />
      {values.registeredInSmaabaatregisteret !== undefined && (
        <AlertWithIllustration
          alertType={AlertType.CONTACT_US_ALERT}
          iconName={IconName.BOAT}
          title={
            values.registeredInSmaabaatregisteret === BooleanFormType.FALSE
              ? getText("boatform.alerttitle.smaabaatregisteretisnotmember")
              : getText("boatform.alerttitle.smaabaatregisteretismember")
          }
          description={
            values.registeredInSmaabaatregisteret === BooleanFormType.FALSE
              ? getText(
                  "boatform.alertdescription.smaabaatregisteretisnotmember",
                )
              : getText("boatform.alertdescription.smaabaatregisteretismember")
          }
          alertId="boat-smaabaatregistrert-status"
          variant="border"
          marginBottom="32px"
        >
          <ReactMarkdown linkTarget="_blank">
            {getText("boatform.infodescription.tilsmaabaatregisteret-1")}
          </ReactMarkdown>
        </AlertWithIllustration>
      )}
    </>
  );
};
